module.exports = __webpack_public_path__ + "static/media/hello-redux.76cbb798.png";